import { useGrowthQuery } from '@/data/useGrowthQuery';
import { growthKeys } from '@/data/queryKeys';
import { fetchDashboard } from '../api';

export function useDashboard() {
  return useGrowthQuery({
    queryKey: growthKeys.dashboard(),
    queryFn: fetchDashboard,
  });
}
